import { rememberCompleteOrderId } from '@core/order-complete-navigation'

export default [
  {
    path: '/order/welcome/',
    name: 'order-welcome',
    component: () => import('@modules/app-steps/step-three/order-complete.vue'),
    meta: {
      requiresAuth: true,
      isWelcomePage: true,
    },
  },
  {
    path: '/order/:id',
    name: 'single-order',
    component: () => import('@/views/order/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/order/:id/misc-sale',
    name: 'order-misc-sale',
    component: () => import('@modules/app-steps/misc-sale/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/order/:id/billing',
    name: 'order-billing',
    component: () => import('@modules/app-steps/step-three/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/order/complete',
    name: 'order-complete',
    component: () => import('@modules/app-steps/step-three/order-complete.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/order/:id/complete',
    redirect: (to) => {
      rememberCompleteOrderId(to.params.id)
      return { name: 'order-complete' }
    },
  },
]
